import React from "react";
import { http } from "../helpers/http.helper";
import EscortCard from "../components/cards/EscortCard";
import CommonTopBar from "../components/layouts/CommonTopBar";
import { Helmet } from "react-helmet";
import { LogoImage } from "../assets/images";
import Navigation from "../components/layouts/Navigation";
import FooterSection from "../components/layouts/FooterSection";

const PornStars = () => {
  const [ads, setAds] = React.useState([]);

  const getAds = React.useCallback(async () => {
    try {
      const { data } = await http.get("/pub/pornstar-ads");
      setAds(data.ads);
    } catch (error) {
      console.log(error);
    }
  }, []);

  React.useEffect(() => {
    getAds();
  }, [getAds]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> {`Privé - Porn Stars`} </title>
        <meta name="title" content={`Privé - Porn Stars`} />

        {/* <!-- Open Graph Meta Tags --> */}
        <meta property="og:title" content={`Privé - Porn Stars`} />

        <meta property="og:image" content={LogoImage} />
        <meta property="og:url" content={`https://privé.xyz/porn-stars`} />
        <meta property="og:type" content="website" />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`Privé - Porn Stars`} />

        <meta name="twitter:image" content={LogoImage} />
        <meta name="twitter:url" content={`https://privé.xyz/porn-stars`} />

        <link rel="canonical" href={`https://privé.xyz/porn-stars`} />
      </Helmet>
      <CommonTopBar selectedCountry="Porn Star Escorts" />
      <main>
        <div className="main-content">
          <div className="main-content-title-wrapper without-filters">
            <div className="main-content-title-container">
              <h1 className="selected-country-name">Porn Stars Escorts</h1>
              <Navigation />
            </div>
          </div>
          {/* <h1 className="page-titles">Pornstar Escorts</h1> */}
          <div className="escort-card-wrapper">
            <div className="escort-card-container">
              {ads.map((ad) => (
                <EscortCard key={ad._id} ad={ad} />
              ))}
            </div>
          </div>
          <FooterSection />
        </div>
      </main>
    </>
  );
};

export default PornStars;
